// Cloak Files attribution claim: posts the cloak_attr cookie payload to
// cloak-file-ws so the marketing-acquired distinct_id + UTMs land on the new
// user's `user_acquisition` row.
//
// Companion to cloakAnalytics.js — cloakAnalytics fires PostHog events from
// the browser, this service hands the same attribution state to the backend
// at signup completion so the funnel stitches end-to-end.
//
// Server side: cloak-file-ws/.../api/analytics/UserAcquisitionService.java
// (POST /1/users/acquisition/claim, APP-auth, form-urlencoded body).
//
// Best-effort: failures are swallowed — attribution must never block signup
// completion or login. Same boundary rule as cloakAnalytics.

const CLAIM_PATH = '/1/users/acquisition/claim';
const ATTR_COOKIE = 'cloak_attr';
let claimedThisTab = false;

function readAttrCookie() {
  try {
    const m = document.cookie.match(new RegExp('(?:^|; )' + ATTR_COOKIE + '=([^;]*)'));
    return m ? JSON.parse(decodeURIComponent(m[1])) : null;
  } catch (e) { return null; }
}

// Map cookie keys (already snake_case, matching server-side property names) to
// a form-encoded body, prefixed with the user email which is the partition key.
function toForm(email, attr) {
  const params = new URLSearchParams();
  params.append('user', email);
  const keys = [
    'distinct_id', 'session_id',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'campaign_id',
    'first_referrer', 'last_referrer', 'first_landing_path',
    'first_touch_ts', 'last_touch_ts',
    'last_stripe_session_id',
  ];
  keys.forEach((k) => {
    const v = attr[k];
    if (v !== undefined && v !== null && v !== '') params.append(k, String(v));
  });
  return params;
}

/**
 * Fire once when /cloak/verify-email succeeds, before the user navigates to
 * login. Idempotent on the backend; per-tab flag here prevents repeats.
 * @param {string} email
 * @returns {Promise<void>}
 */
export function claim(email) {
  if (typeof window === 'undefined') return Promise.resolve();
  if (claimedThisTab) return Promise.resolve();
  if (!email) return Promise.resolve();
  const attr = readAttrCookie();
  if (!attr) return Promise.resolve();
  claimedThisTab = true;
  const body = toForm(email, attr);
  return fetch(CLAIM_PATH, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: body.toString(),
  }).then((res) => {
    if (!res.ok) {
      console.warn('Attribution claim non-2xx', res.status);
    }
  }).catch((err) => {
    console.warn('Attribution claim failed', err);
  });
}
